export interface AuditInfo {
    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;
}

export const createAuditInfo = (createdBy: string): AuditInfo => {
    const date = new Date().toISOString();

    return {
        createdBy,
        updatedBy: createdBy,
        updatedDate: date,
        createdDate: date
    };
};

export const getUpdatedAuditInfo = (audit: AuditInfo, updatedBy: string): AuditInfo => {
    const date = new Date().toISOString();

    return {
        ...audit,
        updatedBy,
        updatedDate: date
    };
};
